import { render, staticRenderFns } from "./footer-component.vue?vue&type=template&id=c409f234&scoped=true"
import script from "./footer-component.vue?vue&type=script&lang=js"
export * from "./footer-component.vue?vue&type=script&lang=js"
import style0 from "./footer-component.vue?vue&type=style&index=0&id=c409f234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c409f234",
  null
  
)

export default component.exports